import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { InlineToastModule } from 'shared';
import { DeliveryPlanViewerComponent } from './delivery-plan-viewer.component';
import { DeliveryPlanViewerStopMarkerComponent } from './stop-marker/delivery-plan-viewer-stop-marker.component';
import { DeliveryPlanViewerLeftPanelComponent } from './left-panel/delivery-plan-viewer-left-panel.component';
import { DeliveryPlanViewerCourierLegendComponent } from './courier-legend/delivery-plan-viewer-courier-legend.component';
import { DeliveryPlanViewerStopsPanelComponent } from './stops-panel/delivery-plan-viewer-stops-panel.component';

@NgModule({
    declarations: [
        DeliveryPlanViewerComponent,
        DeliveryPlanViewerStopMarkerComponent,
        DeliveryPlanViewerLeftPanelComponent,
        DeliveryPlanViewerCourierLegendComponent,
        DeliveryPlanViewerStopsPanelComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        NgbModalModule,
        TranslateModule,
        BsDatepickerModule,
        InlineToastModule,
    ],
    exports: [DeliveryPlanViewerComponent],
})
export class DeliveryPlanViewerModule {}